import { FiExternalLink, FiFileText } from 'react-icons/fi';

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('fr-FR') : '—');

export default function DeliberationCard({ delib }) {
  return (
    <div className="border border-gray-200 rounded p-3 bg-white space-y-1">
      <div className="flex items-center justify-between gap-2">
        <div>
          <div className="text-[12px] font-bold text-gray-800">{delib.numero}</div>
          <div className="text-[11px] text-gray-600 line-clamp-2">{delib.titre}</div>
        </div>
        <div className="flex items-center gap-1">
          {delib.url_html && (
            <a href={delib.url_html} target="_blank" rel="noopener" className="text-blue-600 hover:underline text-[10px]">
              <FiExternalLink className="h-3 w-3 inline" /> CRE
            </a>
          )}
          {delib.url_pdf && (
            <a href={delib.url_pdf} target="_blank" rel="noopener" className="text-blue-600 hover:underline text-[10px]">
              <FiFileText className="h-3 w-3 inline" /> PDF
            </a>
          )}
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2 text-[10px] text-gray-500">
        <div>Type : <span className="font-semibold text-gray-700">{delib.type_classification || '—'}</span></div>
        <div>Publié : {fmtDate(delib.date_publication)}</div>
        <div>Effet : {fmtDate(delib.date_effet)}</div>
      </div>
      <div className="text-[10px]">
        Status : <span className={`px-1.5 py-0.5 rounded font-semibold ${
          delib.status === 'applied' ? 'bg-green-100 text-green-800' :
          delib.status === 'staged' ? 'bg-blue-100 text-blue-800' :
          delib.status === 'rejected' ? 'bg-gray-100 text-gray-700' :
          'bg-yellow-100 text-yellow-800'
        }`}>{delib.status}</span>
      </div>
    </div>
  );
}
